/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const MediumSoundIndicatorIcon = ({
  width = 4,
  height = 12,
  color = '#fff',
  ...props
}: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 4 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.930305 0.798234C1.11326 0.591399 1.42925 0.572043 1.63609 0.755001C3.08516 2.0368 4 3.91177 4 5.99978C4 8.0878 3.08516 9.96277 1.63609 11.2446C1.42925 11.4275 1.11326 11.4082 0.930305 11.2013C0.747346 10.9945 0.766701 10.6785 0.973537 10.4955C2.21713 9.39551 3 7.78939 3 5.99978C3 4.21018 2.21713 2.60405 0.973537 1.50402C0.766701 1.32106 0.747346 1.00507 0.930305 0.798234Z"
      fill={color}
    />
  </svg>
);

export default MediumSoundIndicatorIcon;
